<template>
  <v-container>
    <v-row>
      <v-col sm="12" md="6" lg="6" xl="6">
        <Title title="Subscribe" subtitle="stay up to date" />
        <p class="pb-6">
          Are you interested in meditation? What about health and fitness?
          Subscribe to my newsletter for free fitness classes, useful
          information, and to stay up to date with what I am working on!
        </p>
      </v-col>
      <v-col sm="12" md="6" lg="6" xl="6">
        <v-container>
          <v-card class="card pa-6 mb-8">
            <v-form ref="form">
              <v-container fluid>
                <v-row>
                  <v-col cols="12" v-bind:style="{ display: showMessage }">
                    <p v-bind:class="messageColor">{{ message }}</p>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.firstName"
                      :rules="rules.name"
                      color="purple"
                      type="text"
                      label="First name"
                      name="FirstName"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.email"
                      :rules="rules.email"
                      color="purple"
                      type="email"
                      label="Email"
                      name="Email"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn
                    :disabled="!formIsValid"
                    v-on:click="subscribe"
                    raised
                    v-bind:loading="loading"
                    class="white--text"
                    color="#b697ff"
                  >
                    {{ buttonText }}
                    <v-icon right>{{ this.icon }}</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-form>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Title from "./Title";
import firebase from "firebase/app";
import "firebase/firestore";

firebase.initializeApp({
  projectId: "angela-sette",
  databaseURL: "https://angela-sette.firebaseio.com"
});
const db = firebase.firestore();

export default {
  components: {
    Title
  },
  data() {
    const defaultForm = Object.freeze({
      firstName: "",
      email: ""
    });
    return {
      icon: "mdi-email",
      buttonText: "SUBSCRIBE",
      showMessage: "none",
      message: "",
      loading: false,
      messageColor: "purple--text",
      form: Object.assign({}, defaultForm),
      rules: {
        name: [(val) => (val || "").length > 0 || "What should we call you?"],
        email: [
          (val) =>
            this.validEmail(val) == true ||
            "This field must conatain a valid email address."
        ]
      },
      defaultForm
    };
  },
  computed: {
    formIsValid() {
      return this.form.firstName && this.validEmail(this.form.email);
    }
  },
  methods: {
    resetForm() {
      this.form = Object.assign({}, this.defaultForm);
      this.$refs.form.reset();
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    subscribe() {
      (this.loading = true),
        db
          .collection("subscribers")
          .add({ firstName: this.form.firstName, email: this.form.email })
          .then(() => {
            this.icon = "mdi-check";
            this.buttonText = "SUBCRIBED";
            this.showMessage = ""; //removes display:none
            this.message = "You have successfully been subcribed!";
            this.loading = false;
            this.resetForm();
          })
          .error(() => {
            this.showMessage = ""; //removes display:none
            this.messageColor = "red--text";
            this.message = "An error occured, please try again later.";
            this.loading = false;
          });
    }
  }
};
</script>
